import { lazy } from "react";
import Loadable from "components/Loadable";
import { routeConstants } from "services/keyConstants";

// Lazy-loaded component
const MasterListOfQualityRecords = Loadable(
  lazy(() => import("../MasterListOfQualityRecords"))
);

const CORRoutes = [
  {
    path: routeConstants.COR,
    children: [
      {
        path: ":id",
        element: <MasterListOfQualityRecords />,
      },
    ],
  },
];

export default CORRoutes;
